import React from 'react';

const WeDidItConfetti: React.FunctionComponent = () => {
  return (
    <svg viewBox="0 0 1275 340">
      <g fillRule="evenodd">
        <path d="M556.422 35.379l2.926-2.728 10.23 10.97-2.926 2.728z" />
        <path
          opacity={0.5}
          d="M809.07 42.828l2.801 1.075-3.942 10.27-2.8-1.076zM468.422 282.379l2.926-2.728 4.558 4.888 5.672 6.082-2.926 2.728z"
        />
        <path d="M336.713 279.53l1.806-2.153 7.892 6.622-1.806 2.152z" />
        <path
          opacity={0.2}
          d="M19.482 263l3.971 1.768-6.482 14.56L13 277.56zM257.482 143l3.971 1.768-6.482 14.56L251 157.56z"
        />
        <path d="M996.482 264l3.971 1.768-6.482 14.56L990 278.56zM986.482 75l3.971 1.768-6.482 14.56L980 89.56z" />
        <path
          opacity={0.5}
          d="M1158.367 73l2.367 3.646-13.366 8.68-2.368-3.645z"
        />
        <path opacity={0.2} d="M0 91.677L3.425 89l9.813 12.56-3.426 2.676z" />
        <path
          opacity={0.5}
          d="M1140.367 251l2.367 3.646-13.366 8.68-2.368-3.645zM915.367 165l2.367 3.646-13.366 8.68-2.368-3.645z"
        />
        <path
          opacity={0.2}
          d="M412.76 239l1.573 4.844-17.759 5.77L395 244.77z"
        />
        <path
          opacity={0.5}
          d="M915.76 286l1.573 4.844-17.759 5.77L898 291.77z"
        />
        <path
          opacity={0.2}
          d="M828 264.473l3.724-3.473 12.735 13.656-3.725 3.474z"
        />
        <path
          d="M184.668 40.74l5.152-5.151L187.23 33l-7.767 7.767 2.59 2.588.025-.026 1.073 1.073L178 49.553l2.589 2.59 7.766-7.767-2.588-2.59-.027.027-1.072-1.073z"
          opacity={0.5}
        />
        <path d="M1024.471 184.19l-3.42-6.433-3.233 1.719 5.157 9.698 3.232-1.72-.017-.032 1.339-.712 3.42 6.433 3.233-1.719-5.157-9.698-3.232 1.72.017.032-1.339.712z" />
        <path
          d="M1262.352 52.19l-3.42-6.433-3.233 1.719 5.156 9.698 3.233-1.72-.017-.032 1.339-.712 3.42 6.433 3.233-1.719-5.157-9.698-3.232 1.72.017.032-1.34.712z"
          opacity={0.2}
        />
        <path d="M273.755 57.837L276.796 55l10.4 11.153-3.04 2.836zM105 99.836L108.042 97l10.4 11.153-3.041 2.837zM1256 217.836l3.042-2.836 10.4 11.153-3.041 2.837z" />
        <path
          opacity={0.5}
          d="M1256.435 293.73l-.435-4.136 6.758-.71 8.409-.884.434 4.136zM390.837 293.442L388 290.401l4.97-4.634 6.183-5.767 2.837 3.042z"
        />
        <path d="M1082 141.152l1.806-2.152 7.892 6.622-1.806 2.152zM1231.065 138l9.024 7.572-2.065 2.461-9.024-7.572zM298.81 242c2.034 0 3.702 1.616 3.598 3.65 0 1.198-.313 2.032-1.2 3.075l-.052.052-.052.052-4.222 3.598-.678.573-.678-.573-4.223-3.598-.052-.052-.052-.052c-.834-1.043-1.199-1.877-1.199-3.076 0-2.033 1.668-3.649 3.701-3.649.99 0 1.877.417 2.555 1.095.678-.678 1.564-1.095 2.554-1.095z" />
        <path
          d="M167.81 280c2.034 0 3.702 1.616 3.598 3.65 0 1.198-.313 2.032-1.2 3.075l-.052.052-.052.052-4.222 3.598-.678.573-.678-.573-4.223-3.598-.052-.052-.052-.052c-.834-1.043-1.199-1.877-1.199-3.076 0-2.033 1.668-3.649 3.701-3.649.99 0 1.877.417 2.555 1.095.678-.678 1.564-1.095 2.554-1.095z"
          opacity={0.5}
        />
        <path
          d="M1128.81 139c2.034 0 3.702 1.616 3.598 3.65 0 1.198-.313 2.032-1.2 3.075l-.052.052-.052.052-4.222 3.598-.678.573-.678-.573-4.223-3.598-.052-.052-.052-.052c-.834-1.043-1.199-1.877-1.199-3.076 0-2.033 1.668-3.649 3.701-3.649.99 0 1.877.417 2.555 1.095.678-.678 1.564-1.095 2.554-1.095z"
          opacity={0.2}
        />
        <path d="M1199.81 286c2.034 0 3.702 1.616 3.598 3.65 0 1.198-.313 2.032-1.2 3.075l-.052.052-.052.052-4.222 3.598-.678.573-.678-.573-4.223-3.598-.052-.052-.052-.052c-.834-1.043-1.199-1.877-1.199-3.076 0-2.033 1.668-3.649 3.701-3.649.99 0 1.877.417 2.555 1.095.678-.678 1.564-1.095 2.554-1.095z" />
        <path
          d="M132.487 186c3.112 0 5.666 2.474 5.506 5.586 0 1.836-.479 3.112-1.836 4.708l-.08.08-.08.08-6.463 5.506-1.038.878-1.037-.878-6.464-5.506-.08-.08-.08-.08c-1.276-1.596-1.835-2.872-1.835-4.708 0-3.112 2.554-5.586 5.666-5.586 1.516 0 2.873.638 3.91 1.676 1.038-1.038 2.394-1.676 3.91-1.676z"
          opacity={0.5}
        />
      </g>
    </svg>
  );
};
export default WeDidItConfetti;
